import { render, staticRenderFns } from "./single.vue?vue&type=template&id=a9b1cbf2"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"
import style0 from "./single.vue?vue&type=style&index=0&id=a9b1cbf2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports